<template>
  <div class="main-rating-content">
    <transition name="fade">
      <div
        v-show="overlayShown"
        class="overlay"/>
    </transition>
    <span
      v-show="!tags_loaded"
      class="el-icon-loading"/>

    <div
      v-button-event="{buttonText: 'thumps-up', contentType: 'podcast', contentData: {uuid: podcast_id}}"
      v-if="show_like"
      v-show="tags_loaded"
      :class="isThumbsUpRatingSet ? 'bg-dark-grey b-0' : ''"
      class="like"
      data-test="thumbsup"
      @click="clickRating(thumbs_up_code)">
      <img
        v-if="isThumbsUpRatingSet"
        src="../assets/images/ic_thumbs_up_white.svg">
      <img
        v-else
        src="../assets/images/ic_thumbs_up_gray.svg">
    </div>

    <div
      v-button-event="{buttonText: 'thumps-down', buttonLink: null}"
      v-if="show_dislike"
      v-show="tags_loaded"
      :class="isThumbsDownRatingSet ? 'bg-dark-grey b-0' : ''"
      class="dislike"
      data-test="thumbsdown"
      @click="clickRating(thumbs_down_code)">
      <img
        v-if="isThumbsDownRatingSet"
        src="../assets/images/ic_thumbs_down_white.svg">
      <img
        v-else
        src="../assets/images/ic_thumbs_down_gray.svg">
    </div>

    <el-dialog
      :visible.sync="show_rating_modal"
      :close="true"
      :append-to-body="true"
      :lock-scroll="true"
      custom-class="rating-modal"
      width="95%">
      <div
        v-show="show_thumbs_up">
        <loader
          v-show="!tags_loaded"
          :with-margin="true"
          label="Fetching Tags"/>
        <div
          v-show="tags_loaded"
          class="content">
          <h4>Thanks for rating!</h4>
          <p>Can you tell us more about what you liked?</p>
          <button
            v-button-event="{buttonText: item.title, buttonLink: null}"
            v-for="(item,index) in thumbs_up_tags"
            :class="item.selected ? 'btn-dark' : 'btn-transparent'"
            :key="index"
            class="el-button"
            @click="selectTags(item,index,thumbs_up_code)">
            {{ item.title }}
          </button>
          <br>
          <el-button
            v-button-event="{buttonText: 'Submit Feeback', buttonLink: null}"
            :loading="submitting"
            :disabled="!isThumbsUpSelected"
            type="primary"
            class="submit bg-primary"
            @click.native="saveRating(thumbs_up_code)">
            Submit
          </el-button>
        </div>
      </div>
      <div
        v-show="show_thumbs_down">
        <div
          v-show="!report_content"
          class="tags">
          <loader
            v-show="!tags_loaded"
            label="Fetching Tags"/>
          <div
            class="content">
            <h4>Thanks for rating!</h4>
            <p>Can you tell us more about what you didn't like?</p>
            <button
              v-button-event="{buttonText: item.title, buttonLink: null}"
              v-for="(item,index) in thumbs_down_tags"
              :class="item.selected ? 'btn-dark' : 'btn-transparent'"
              :key="index"
              class="el-button"
              @click="selectTags(item,index,thumbs_down_code)">
              {{ item.title }}
            </button>
            <br>
            <el-button
              :loading="submitting"
              :disabled="!isThumbsDownSelected"
              type="primary"
              class="submit"
              @click.native="saveRating(thumbs_down_code)">Submit</el-button>
          </div>
          <p
            v-if="tags_loaded"
            v-show="!report_content"
            class="link"
            @click="report_content = true">Report this content</p>
        </div>
        <div
          v-show="tags_loaded && report_content"
          class="feedback">
          <div
            class="report">
            <h4>Report this content</h4>
            <p>Please tell us why you are reporting this content</p>
            <p>Your feedback..</p>
            <el-input
              :rows="3"
              v-model="feedback"
              type="textarea"
              placeholder="Please input"/>
            <el-button
              v-button-event="{buttonText: 'Submit Feeback', buttonLink: null}"
              :loading="submitting"
              type="primary"
              class="submit"
              @click="saveFeedback">
              Submit
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <div
      :class="show_thumbs_up && !isSafariMobile ? 'translateY0' : ''"
      class="thumbs-up"
      data-test="popup-thumbsup">
      <span
        class="el-icon-close"
        @click="removeOverlay"/>
      <el-row
        type="flex"
        align="center"
        justify="center">
        <el-col
          :md="{span:16}"
          :sm="{span:18}"
          :xs="{span:22}">
          <loader
            v-show="!tags_loaded"
            label="Fetching Tags"/>
          <div
            v-if="tags_loaded"
            class="content">
            <h4>Thanks for rating!</h4>
            <p>Can you tell us more about what you liked?</p>
            <button
              v-button-event="{buttonText: item.title, buttonLink: null}"
              v-for="(item,index) in thumbs_up_tags"
              :class="item.selected ? 'btn-dark' : 'btn-transparent'"
              :key="index"
              data-test="rating-thumbsup"
              class="el-button"
              @click="selectTags(item,index,thumbs_up_code)">
              {{ item.title }}
            </button>
            <br>
            <el-button
              v-button-event="{buttonText: 'Submit Feeback', buttonLink: null}"
              :loading="submitting"
              :disabled="!isThumbsUpSelected"
              type="primary"
              class="submit bg-primary"
              data-test="rating-submit"
              @click.native="saveRating(thumbs_up_code)">
              Submit
            </el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <div
      :class="show_thumbs_down && !isSafariMobile ? 'translateY0' : ''"
      class="thumbs-down"
      data-test="popup-thumbsdown">
      <span
        class="el-icon-close"
        @click="removeOverlay"/>
      <el-row
        type="flex"
        justify="center">
        <el-col
          :md="{span:16}"
          :sm="{span:18}"
          :xs="{span:24}">
          <loader
            v-show="!tags_loaded"
            label="Fetching Tags"/>
          <div
            v-show="!report_content"
            v-if="tags_loaded"
            class="content">
            <h4>Thanks for rating!</h4>
            <p>Can you tell us more about what you didn't like?</p>
            <button
              v-button-event="{buttonText: item.title, buttonLink: null}"
              v-for="(item,index) in thumbs_down_tags"
              :class="item.selected ? 'btn-dark' : 'btn-transparent'"
              :key="index"
              class="el-button"
              data-test="rating-thumbsdown"
              @click="selectTags(item,index,thumbs_down_code)">
              {{ item.title }}
            </button>
            <br>
            <el-button
              :loading="submitting"
              :disabled="!isThumbsDownSelected"
              type="primary"
              class="submit"
              data-test="rating-submitthumbsdown"
              @click.native="saveRating(thumbs_down_code)">Submit</el-button>
          </div>
          <p
            v-if="tags_loaded"
            v-show="!report_content"
            class="link"
            @click="report_content = true">Report this content</p>
        </el-col>
      </el-row>
      <el-row
        type="flex"
        justify="center">
        <el-col
          :md="{span:16}"
          :sm="{span:18}"
          :xs="{span:24}">
          <div
            v-if="tags_loaded"
            v-show="report_content"
            class="report">
            <h4>Report this content</h4>
            <p>Please tell us why you are reporting this content</p>
            <p>Your feedback..</p>
            <el-input
              :rows="3"
              v-model="feedback"
              type="textarea"
              placeholder="Please input"/>
            <el-button
              v-button-event="{buttonText: 'Submit Feeback', buttonLink: null}"
              :loading="submitting"
              type="primary"
              class="submit"
              @click="saveFeedback">
              Submit
            </el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <login-modal
      v-if="show_login"
      :show_modal="show_login"
      @modalClosed="show_login = false"/>
  </div>
</template>
<script>
import * as log from 'loglevel';
import VueContentLoading from 'vue-content-loading';
import Loader from './Loader';
import PodcastService from '../services/Podcast';
import EpisodeService from '../services/Episode';
import Login from '../pages/onboarding/SignIn';
import LoginModal from './LoginModal';

export default {
  name: 'Rating',
  components: {
    Loader, VueContentLoading, Login, LoginModal,
  },
  props: {
    podcast_id: {
      type: String,
      default: '',
    },
    show_like: {
      type: Boolean,
      default: false,
    },
    show_dislike: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      podcast_service: new PodcastService(),
      episode_service: new EpisodeService(),
      thumbs_up_tags: [],
      thumbs_down_tags: [],
      received_rating: [],
      thumbs_up_code: 'thumbs_up',
      thumbs_down_code: 'thumbs_down',
      positive_rating: null,
      show_thumbs_up: false,
      show_thumbs_down: false,
      tags_loaded: true,
      submitting: false,
      report_content: false,
      show_login: false,
      feedback: '',
      show_rating_modal: false,
      is_safari_and_mobile: false,
    };
  },
  computed: {
    isThumbsUpSelected() {
      return this.thumbs_up_tags.filter(item => item.selected).length;
    },
    isThumbsDownSelected() {
      return this.thumbs_down_tags.filter(item => item.selected).length;
    },
    isThumbsUpRatingSet() {
      return this.positive_rating === this.thumbs_up_code;
    },
    isThumbsDownRatingSet() {
      return this.positive_rating === this.thumbs_down_code;
    },
    isFeedbackEmpty() {
      return this.feedback.length < 10;
    },
    isLoggedIn() {
      return this.$store.getters.loggedIn;
    },
    overlayShown() {
      return (this.show_thumbs_up || this.show_thumbs_down) && !this.isSafariMobile;
    },
  },
  watch: {
    show_rating_modal() {
      if (!this.show_rating_modal) this.report_content = false;
    },
  },
  mounted() {
    this.getRatings();
    this.getFeedback();
  },
  methods: {
    clickRating(type) {
      if (!this.isLoggedIn) {
        this.show_login = true;
        return;
      }
      this.show_thumbs_up = type === this.thumbs_up_code;
      this.show_thumbs_down = type === this.thumbs_down_code;
      this.show_rating_modal = this.isSafariMobile;
    },
    getRatings() {
      return this.podcast_service.getRatings()
        .then((res) => {
          this.thumbs_up_tags = res.thumbs_up.rating_answers.map(item => ({
            ...item,
            selected: false,
          }));
          this.thumbs_down_tags = res.thumbs_down.rating_answers.map(item => ({
            ...item,
            selected: false,
          }));
          this.tags_loaded = true;
          this.getSavedRating();
        })
        .catch((err) => {
          log.info(`Error fetching rating tags: ${err.message}`);
          this.showErrorMsg('Failed to fetch ratings.');
        });
    },
    removeOverlay() {
      this.show_thumbs_up = false;
      this.show_thumbs_down = false;
      this.report_content = false;
    },
    selectTags(item, index, type) {
      if (type === this.thumbs_up_code) {
        (this.thumbs_up_tags[index].selected = !this.thumbs_up_tags[index].selected);
      } else if (type === this.thumbs_down_code) {
        (this.thumbs_down_tags[index].selected = !this.thumbs_down_tags[index].selected);
      } else {
        log.warn('Invalid Type in selectTagsFunction');
      }
    },
    filterSelectedTags(type) {
      if (type === this.thumbs_up_code) {
        return this.thumbs_up_tags.filter(item => item.selected).map(item => ({
          code: item.code,
          title: item.title,
        }));
      }
      if (type === this.thumbs_down_code) {
        return this.thumbs_down_tags.filter(item => item.selected).map(item => ({
          code: item.code,
          title: item.title,
        }));
      }
      log.warn('Invalid Type Code in filterSelectedTags Function');
      return null;
    },
    clearTags(type) {
      if (type === this.thumbs_up_code) {
        this.thumbs_down_tags.forEach((item) => { item.selected = false; });
      } else if (type === this.thumbs_down_code) {
        this.thumbs_up_tags.forEach((item) => { item.selected = false; });
      } else {
        log.warn('Invalid code in clearTags');
      }
    },
    getSavedRating() {
      if (!this.isLoggedIn) {
        return;
      }
      const vm = this;
      this.podcast_service.getPodcastRating(this.podcast_id)
        .then((res) => {
          if (!Object.keys(res).length) return;
          const code = res.ratings && res.ratings.code;
          this.received_rating = res.ratings.rating_answers;
          if (!code || !this.received_rating) return;
          if (code === this.thumbs_up_code) {
            res.ratings.rating_answers.forEach((item) => {
              const index = vm.thumbs_up_tags.findIndex(elem => item.code === elem.code);
              if (index !== -1) {
                vm.thumbs_up_tags[index].selected = true;
                this.positive_rating = this.thumbs_up_code;
              }
            });
          } else if (code === this.thumbs_down_code) {
            res.ratings.rating_answers.forEach((item) => {
              const index = vm.thumbs_down_tags.findIndex(elem => item.code === elem.code);
              if (index !== -1) {
                vm.thumbs_down_tags[index].selected = true;
                this.positive_rating = this.thumbs_down_code;
              }
            });
          }
          this.tags_loaded = true;
        })
        .catch((error) => {
          log.warn(error.message);
          this.tags_loaded = true;
        });
    },
    saveRating(type) {
      this.submitting = true;
      const tags = this.filterSelectedTags(type);
      this.clearTags(type);
      this.podcast_service.updatePodcastRatings(this.podcast_id, type, tags)
        .then((res) => {
          this.removeOverlay();
          if (res.success) {
            this.triggerRatingEvent(type);
            this.positive_rating = type;
            this.showSuccessMsg('Ratings Saved!');
          } else {
            this.showErrorMsg('Your ratings were not saved!');
          }
          this.submitting = false;
          this.show_rating_modal = false;
        })
        .catch((error) => {
          this.submitting = false;
          this.showErrorMsg(error.message);
          log.warn(error.message);
        });
    },
    saveFeedback() {
      if (this.isNullOrWhiteSpace(this.feedback)) {
        this.showErrorMsg('Feedback can\'t be empty!');
        return;
      }
      this.submitting = true;
      if (this.type === 'episode') {
        this.episode_service
          .giveEpisodeFeedback(this.podcast_id, this.feedback)
          .then((res) => {
            this.submitting = false;
            this.removeOverlay();
            this.positive_rating = this.thumbs_down_code;
            if (res.success) {
              this.showSuccessMsg('Feedback saved!');
            } else {
              this.showErrorMsg('Couldn\'t save your feedback. Please try again!');
            }
          })
          .catch((error) => {
            log.warn(error.message);
          });
      }
      if (this.type === 'show') {
        this.podcast_service
          .savePodcastFeedback(this.podcast_id, this.feedback)
          .then((res) => {
            this.submitting = false;
            this.removeOverlay();
            this.positive_rating = this.thumbs_down_code;
            if (res.success) {
              this.showSuccessMsg('Feedback Saved!');
            } else {
              this.showErrorMsg('Couldn\'t save your feedback. Please try again!');
            }
          })
          .catch((error) => {
            log.warn(error.message);
          })
          .then(() => {
            this.show_rating_modal = false;
          });
      }
    },
    getFeedback() {
      if (!this.isLoggedIn) {
        return;
      }
      if (this.type === 'episode') {
        this.episode_service.getEpisodeFeedback(this.podcast_id)
          .then((res) => {
            this.feedback = res.content;
            if (res.content) {
              this.positive_rating = this.thumbs_down_code;
            }
          })
          .catch((error) => {
            log.warn(error.message);
          });
      } else if (this.type === 'show') {
        this.podcast_service.getPodcastFeedback(this.podcast_id)
          .then((res) => {
            this.feedback = res.content;
            if (res.content) {
              this.positive_rating = this.thumbs_down_code;
            }
          })
          .catch((error) => {
            log.warn(error.message);
          });
      } else {
        log.warn('Wrong Type code in getFeedback Function');
      }
    },
    showNotification() {
      this.showErrorMsg('You need to be logged in to perform this action.');
    },
    triggerRatingEvent(type) {
      const data = { show_uuid: this.podcast_id };
      if (type === this.thumbs_up_code) {
        data.show_like = true;
        data.show_dislike = true;
      }
      this.$analytics.track('show_rating', data);
    },
  },
};
</script>
<style lang="scss">
@import "../assets/scss/variables.scss";

.main-rating-content {
  @media (max-width: 567px) {
    display: flex;
  }
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.5);
  transition: .2s all ease-in-out;
  z-index: 999; // Keep it smaller than the size of Rating modal
}
.like,
.dislike {
  width: 40px;
  height: 40px;
  border: 1px solid $gray;
  box-sizing: border-box;
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
  cursor: pointer;
  svg {
    width: 24px;
    height: 24px;
  }
}
.bg-primary {
  border: none !important;
}
.thumbs-up,
.thumbs-down {
  background-color: #fff;
  position: fixed;
  height: 410px;
  width: 50%;
  max-width: 712px;
  z-index: 999;
  text-align: center;
  bottom: 0px;
  left: 50%;
  transform: translate(-47%,100%);
  border-radius: 6px;
  transition: 0.3s all ease-in-out;
  .el-button[disabled] {
    height: 48px;
    width: 126px;
    background-color: #AFE7F1;
    border-color: transparent;
  }
  .link {
    text-decoration: underline;
    color: $black;
    // margin-top: 25px;
    cursor: pointer;
  }
  .el-icon-close {
    position: absolute;
    right: 20px;
    cursor: pointer;
    top: 20px;
    font-size: 24px !important;
    font-weight: bolder;
    z-index: 10000;
  }
  .content {
    .btn-transparent,
    .btn-dark {
      margin: 0px 8px 8px 0 !important;
      padding: 9px 15px !important;
      font-size: 14px;
    }
    .btn-dark {
      color: $black !important;
      background-color: $peach !important;
    }
    .btn-dark:hover {
      background-color: $peach !important;
      color: $black !important;
    }
    .btn-transparent:hover {
      background-color: #fff !important;
      color: $black !important;
      border: 1px solid $black;
    }
    h4 {
      font-weight: 400;
      margin: 64px 0 8px 0;
      font-size: 24px;
      color: $black;
    }
    p {
      color: $black;
      font-size: 16px;
      margin-bottom: 24px;
    }
    .submit {
      // margin-top : 40px;
      margin-top : 15px;
      height: 48px;
      width: 126px;
    }
  }
  .report {
    width: 60%;
    margin: auto;
    h4 {
      font-weight: 400;
      margin-bottom: 0.8rem;
      font-size: 24px;
      color: $black;
    }
    p {
      color: $gray;
      font-size: 16px;
      color: $gray;
    }
    p:nth-child(3) {
      margin-top: 20px;
      color: $black;
    }
    .el-button--info {
      margin-top: 40px;
      width: 112px;
    }
    .el-textarea {
      width: 100%;
      textarea {
        border: 1px solid $light-gray2 !important;
        border-radius: 7px;
        resize: none;
      }
    }
    .submit {
      margin-top: 15px !important;
      width: 112px;
      padding: 15px !important;
    }
  }
}
.translateY0{
  transform: translate(-47%,0);
  transition: 0.4 s all ease-in-out;
}
.translateY100{
  transform: translate(-47%,100%);
  transition: 0.4 s all ease-in-out;
}
@media(max-width: 1024px) {
  .thumbs-up, .thumbs-down {
    width:60% !important;
  }
}
@media(max-width: 768px) {
  .thumbs-up, .thumbs-down {
    width:80% !important;
    padding-bottom:50px;
    .report {
      width:80% !important;
    }
  }
}
@media(max-width: 375px) {
  .thumbs-up, .thumbs-down {
    width:90% !important;
    left:47%;
    .report {
      width:90% !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/Rating.vue